import React, { useCallback, useState, useEffect } from "react";
import {loadStripe} from '@stripe/stripe-js';
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import { CartProvider } from "./CartContext";
import CartDrawer from "./CartDrawer";
import Cart, { ProductList } from "./Cart";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// This is your secret API key.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "pk_live_51R79ejJQgQGbk1p5YdHddxoDbVG6Qt0k7Asvd7JmO3IcfXb8bgZOHobP5G5LWG636sLFGa9aKbpvbqORv6o1ge2700LuLe5VXC");

const CheckoutForm = () => {
  const fetchClientSecret = useCallback(() => {
    // Create a Checkout Session
    return fetch("https://stripe-shop-backend-gsck.onrender.com/create-checkout-session", {
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => data.clientSecret);
  }, []);

  const options = {fetchClientSecret};

  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={options}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}

const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sessionId = urlParams.get('session_id');

    fetch(`https://stripe-shop-backend-gsck.onrender.com/session-status?session_id=${sessionId}`)
      .then((res) => res.json())
      .then((data) => {
        setStatus(data.status);
        setCustomerEmail(data.customer_email);
      });
  }, []);

  if (status === 'open') {
    return (
      <Navigate to="/checkout" />
    )
  }

  if (status === 'complete') {
    return (
      <section id="success">
        <p>
          Thank you for shopping with us! A confirmation email will be sent to {customerEmail} shortly.

          If you have any questions, please email <a href="mailto:rubbersklton@gmail.com">rubbersklton@gmail.com</a>.
        </p>
      </section>
    )
  }

  return null;
}

export default function App() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  return (
    <CartProvider>
      {/* Hide the floating cart button when drawer is open */}
      {!drawerOpen && (
        <button className="cart-fab" onClick={() => setDrawerOpen(true)}>
          🛒 Cart
        </button>
      )}
      <CartDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} />
      <Routes>
        <Route path="/" element={
          <div className="App">
            {/* Removed 'Your Checkout' heading as requested */}
            <ProductList />
          </div>
        } />
        <Route path="/cart-embed" element={<Cart />} />
      </Routes>
    </CartProvider>
  );
}